/**
 * Memoized selectors for crew highlights
 */

import { createSelector } from '@reduxjs/toolkit';

export const selectCrewHighlightsState = state => state.crewHighlights || {};

export const selectHighlightsByCrewId = createSelector(
  [selectCrewHighlightsState],
  crewHighlightsState => crewHighlightsState.highlightsByCrewId || {}
);

export const selectCrewHighlightsLoading = createSelector(
  [selectCrewHighlightsState],
  crewHighlightsState => crewHighlightsState.fetchInProgress || false
);

export const selectCrewHighlightsError = createSelector(
  [selectCrewHighlightsState],
  crewHighlightsState => crewHighlightsState.fetchError || null
);

export const selectCrewHighlightsMetadata = createSelector(
  [selectCrewHighlightsState],
  crewHighlightsState => ({
    lastFetchTime: crewHighlightsState.lastFetchTime || null,
  })
);
